{
  "system": "система",
  "subtitle_one": "показана {{shown}} из {{count}} записи",
  "subtitle_few": "показано {{shown}} из {{count}} записей",
  "subtitle_many": "показано {{shown}} из {{count}} записей",
  "subtitle_other": "показано {{shown}} из {{count}} записей",
  "searchPlaceholder": "Поиск по всем полям",
  "searchLabel": "Поиск по журналу",
  "allActions": "все действия",
  "showFullDetails": "Показать подробности целиком",
  "loadFailed": "Не удалось загрузить журнал",
  "loadFailedHint": "{{reason}} Для чтения журнала нужно право audit:read.",
  "nothingFound": "Ничего не нашлось",
  "nothingFoundHint": "Поиск идёт по действию, пользователю, объекту, адресу и подробностям записи. Попробуйте часть слова или снимите фильтр по действию.",
  "emptyTitle": "Записей пока нет",
  "emptyHint": "Журнал заполняется сам: сюда попадают входы, изменения пользователей и площадок, подключения к устройствам и файловые операции.",
  "loadMore": "Показать ещё",
  "dialogLabel": "Подробности записи журнала",
  "escapeHint": "Escape — закрыть",
  "column": {
    "at": "Время",
    "action": "Действие",
    "user": "Пользователь",
    "target": "Объект",
    "ip": "Адрес",
    "details": "Подробности"
  },
  "action": {
    "login": "вход",
    "loginFailed": "неудачный вход",
    "logout": "выход",
    "refreshReuse": "повторное использование токена",
    "passwordChanged": "смена пароля",
    "userInvited": "приглашён пользователь",
    "userUpdated": "изменён пользователь",
    "userDeactivated": "отключён пользователь",
    "rolesChanged": "изменены роли",
    "orgUpdated": "изменена организация",
    "siteCreated": "создана площадка",
    "siteUpdated": "изменена площадка",
    "siteDeleted": "удалена площадка"
  }
}
